import React, { useRef, useEffect } from 'react';

import { service } from './config';
import MemberJoinInjector from '../../../library/memberjoin/MemberJoinInjector';
import DesktopLayerPopup from '../../common/DesktopLayerPopup';
import KidInfoNotLogin from './components/KidInfoNotLogin';
import LevelSelection from './components/LevelSelection';
import { AddtionalStudent } from './components/AddtionalStudent';

// Type definitions
type StudentInfo = {
    key: number;
    kid_name: string;
    kid_gender: string;
    kid_birth_year: number | null;
    kid_birth_month: number | null;
    kid_birth_day: number | null;
    checkList?: any;
    isOneMoreRequest?: boolean;
    [key: string]: any;
};
type Student = {
    auth_human_name?: string;
    [key: string]: any;
};
type Props = {
    studentInfoList: StudentInfo[];
    setStudentInfoList: (list: StudentInfo[]) => void;
    studentList?: Student[]; // optional, for backward compatibility
};

const WinkFreeStudyNotLoginStep02: React.FC<Props> = ({ studentInfoList, setStudentInfoList, studentList = [] }) => {
    const studentSeq = useRef<number>(
        studentInfoList.length === 0 ? 0 : Math.max(...studentInfoList.map((info) => info.key))
    );

    useEffect(() => {
        if (!studentInfoList || studentInfoList.length === 0) {
            const defaultStudentInfo = service.getDefaultStudentInfo();
            setStudentInfoList([{ key: studentSeq.current, ...defaultStudentInfo }]);
        }
        // eslint-disable-next-line
    }, []);

    const addStudentInfo = () => {
        if (!studentInfoList[0]?.kid_name) {
            return DesktopLayerPopup.notice({
                message: '아이의 이름을 입력해 주세요.',
            });
        }
        if (
            !studentInfoList[0]?.kid_birth_year ||
            !studentInfoList[0]?.kid_birth_month ||
            !studentInfoList[0]?.kid_birth_day
        ) {
            return DesktopLayerPopup.notice({
                message: '아이의 생년월일을 입력해 주세요.',
            });
        }
        studentSeq.current += 1;
        const defaultStudentInfo = service.getDefaultStudentInfo();
        setStudentInfoList([...studentInfoList, { key: studentSeq.current, ...defaultStudentInfo }]);
    };

    const removeStudentInfo = (keyToRemove: number) => {
        const filteredStudentInfoList = studentInfoList.filter((item) => item.key !== keyToRemove);
        setStudentInfoList(filteredStudentInfoList);
    };

    const onChangeStudentInfo = (
        { kid_name, kid_birth_year, kid_birth_month, kid_birth_day, kid_gender, checkList }: StudentInfo,
        idx: number
    ) => {
        const studentInfo = studentInfoList.find(({ key }) => key === idx);
        if (!studentInfo) return;
        const isSameKidName =
            kid_name &&
            studentInfo.kid_name !== kid_name &&
            studentList?.some(({ auth_human_name }) => auth_human_name === kid_name.trim());
        // TODO year, month, day 모두 변경되면 checkList 도 변경되어야 함
        setStudentInfoList(
            studentInfoList.map((stuInfo, index) => {
                if (index === idx) {
                    return {
                        ...stuInfo,
                        ...(kid_name ? { kid_name } : {}),
                        ...(kid_birth_year ? { kid_birth_year } : {}),
                        ...(kid_birth_month ? { kid_birth_month } : {}),
                        ...(kid_birth_day ? { kid_birth_day } : {}),
                        ...(kid_gender ? { kid_gender } : {}),
                        ...(checkList ? { checkList } : {}),
                        ...(isSameKidName ? { isOneMoreRequest: true } : {}),
                    };
                }
                return stuInfo;
            })
        );
    };
    return (
        <div>
            {studentInfoList.map((studentInfo, idx, originalArr) => (
                <div key={studentInfo.key}>
                    <KidInfoNotLogin
                        studentInfo={studentInfo}
                        onChangeStudentInfo={(newStudentInfo: StudentInfo) => onChangeStudentInfo(newStudentInfo, idx)}
                    />
                    <LevelSelection
                        studentInfo={studentInfo}
                        onChangeStudentInfo={(newStudentInfo: StudentInfo) => onChangeStudentInfo(newStudentInfo, idx)}
                    />
                    <AddtionalStudent
                        studentInfoList={studentInfoList}
                        idx={idx}
                        removeStudentInfo={removeStudentInfo}
                        addStudentInfo={addStudentInfo}
                        originalArr={originalArr}
                    />
                </div>
            ))}
        </div>
    );
};

export default MemberJoinInjector()(WinkFreeStudyNotLoginStep02);
